import BannerComp from "../components/BannerComp";
import CtaComp from "../components/CtaComp";
import GridComponent from "../components/GridComponent";
import Seo from "../components/Seo";
import Testimonials from "../components/Testimonials";
import WhyChooseUs from "../components/WhyChooseUs";
import { assurances, metrics } from "../data/grid-data";
import { googleReviews } from "../data/testimonials";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section4 from "./Section4";
import Section7 from "./Section7";
import Section8 from "./Section8";

const seo = {
  title: "Physicians Success Partners | Medical Billing & RCM Services",
  description:
    "Physicians Success Partners (PSP) delivers expert medical billing, Coding denial management, and RCM services across more than 30 healthcare specialties.",
  keywords:
    "medical billing, revenue cycle management, medical coding, healthcare billing services, denial management, prior authorization",
  schema: [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Physicians Success Partners",
      url: "https://psprcm.us/",
      logo: "https://psprcm.us/logo/main-logo.webp",
      description:
        "Physicians Success Partners (PSP) delivers expert medical billing, Coding denial management, and RCM services across more than 30 healthcare specialties.",
      telephone: "+1 6155536787",
      email: "info@psprcm.us",
      sameAs: [
        "https://www.facebook.com/psprcmus",
        "https://www.instagram.com/psprcmus/",
        "https://www.pinterest.com/psprcmus/",
      ],
      address: {
        "@type": "PostalAddress",
        streetAddress: "1616 Westgate Circle",
        addressLocality: "Brentwood",
        addressRegion: "TN",
        postalCode: "37027",
        addressCountry: "USA",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.9",
        bestRating: "5",
        worstRating: "1",
        ratingCount: "36",
        itemReviewed: {
          "@type": "Organization",
          name: "Physicians Success Partners",
          url: "https://psprcm.us/",
        },
      },
      review: googleReviews.map((review) => ({
        "@type": "Review",
        author: review.name,
        reviewRating: {
          "@type": "Rating",
          ratingValue: String(review.rating),
        },
        datePublished: review.datePublished,
        reviewBody: review.review,
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath="/"
        schema={seo.schema}
      />
      <BannerComp
        heading="Comprehensive Medical Billing Services for Providers Across The United States"
        paragraph="Physicians Success Partners is a leading nationwide medical billing company delivering accurate billing and coding services that improve efficiency, reduce errors, and optimize revenue cycle performance for healthcare practices."
        BannerBgImg="home"
        form={true}
      />

      <Section1 />
      <Section2 />
      <CtaComp
        kicker="Scalable & Affordable"
        heading="Start Your PSP Billing at 6% Scalable & Affordable"
        description="Competitive pricing, dependable execution, and scalable support designed to help your practice grow with more clarity and less operational pressure."
        buttonLabel="Let's Begin"
        buttonLink="/contact"
      />
      <Testimonials />
      <Section4 />

      <GridComponent
        kicker="Physicians"
        heading="Welcome Physicians Success Partners!"
        description="We start with a comprehensive practice analysis when taking over a practice's revenue cycle. We thoroughly scrutinize every aspect, from credentialing and enrollment to claim processing. Our standout feature is our ability to conduct detailed comparisons between providers' contractual rates and standard rates in their specific area. This enables us to negotiate the best rates, ensuring fair reimbursements for our clients and addressing any discrepancies."
        metrics={metrics}
        panelEyebrow="Operational Confidence"
        panelHeading="Built to support consistent billing outcomes across every stage of the process."
        assurances={assurances}
      />

      <WhyChooseUs />
      <Section7 />
      <Section8 />
    </>
  );
}
